import { render, staticRenderFns } from "./SheXiangTouGuDing.vue?vue&type=template&id=0b864fd2&scoped=true&"
import script from "./SheXiangTouGuDing.vue?vue&type=script&lang=js&"
export * from "./SheXiangTouGuDing.vue?vue&type=script&lang=js&"
import style0 from "./SheXiangTouGuDing.vue?vue&type=style&index=0&id=0b864fd2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b864fd2",
  null
  
)

export default component.exports